export const combineURLSearchParams = (
  params1: URLSearchParams,
  params2: URLSearchParams
): URLSearchParams => {
  const combined = new URLSearchParams(params1)
  const keysSet = new Set(combined.keys())

  params2.forEach((value, key) => {
    if (!keysSet.has(key)) {
      combined.append(key, value)
    }
  })

  return combined
}
